export default "__VITE_ASSET__BCnvmggB__"